<template>
  <div class="container confirmacion">
    <div class="header">
      <div id="navigation-back" @click.prevent="back">
        <figure id="back-figure">
          <img src="../../static/img/back.png" alt="Volver">
        </figure>
      </div>
      <div id="navigation-home" @click.prevent="goInicio">
        <figure id="home-figure">
            <img src="../../static/img/home.png" alt="Inicio">
        </figure>
      </div>
    </div>
    <div class="section section-confirmacion">
      <div class="logo">
        <figure>
          <img src="../assets/logo.png" alt="DIRECTV">
        </figure>
      </div>
      <div>
        <h2>¡LISTO!</h2>
        <p>Enviaremos un SMS para confirmar su participación.</p>
        <h2>¡MUCHAS GRACIAS!</h2>
      </div>
      <div class="nuevo-participante">
        <div>
          <figure>
            <img src="../../static/img/participante.png" alt="Camara">
          </figure>
          <b-button class="link"
            @click.prevent="nuevoParticipante">NUEVO PARTICIPANTE</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  created () {
  },
  methods: {
    nuevoParticipante () {
      this.$router.push({ name: 'SeleccionMetodo' });
    },
    back () {
      this.$router.go(-1)
    },
    goInicio () {
      this.$router.push({ name: 'Inicio' });
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Confirmacion.vue